import React from 'react';
import { Link } from "react-router-dom";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Badge from 'react-bootstrap/Badge';
import Container from 'react-bootstrap/Container';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

function SearchResults({ entries, queryParam }) {
  if (!entries) return null;

  return (
    <Container id="search-results" fluid>
      <div className='query-matches'>{entries.length} matches for <em>{queryParam}</em></div>
      {entries.map(article => (
        <Row key={article.fields.url || article.sys?.id}>
          <Col>
            <h4><Link to={article.fields.url}>{article.fields.heading}</Link></h4>
            <div className='tagline'>{article.fields.subtitle}</div>
            <div id='search-body'>
              <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                {article.fields.body}
              </ReactMarkdown>
            </div>
            {article.fields.tag && article.fields.tag.map(tag => (
              <Link key={tag} to={"/search?t=" + encodeURIComponent(tag)}>
                <Badge
                  id='tag'
                  style={{ maxWidth: '100%', textOverflow: 'ellipsis', overflow: 'hidden' }}
                  variant="success">
                  {tag}
                </Badge>
              </Link>
            ))}
            <hr />
          </Col>
        </Row>
      ))}
    </Container>
  );
}

export default SearchResults;
